import { Outlet, createBrowserRouter } from "react-router-dom";
import SignIn from "./pages/sign-in";
import { RoutePath } from "./constants";
import BookManagement from "./pages/admin/book-management";
import AdminLayout from "./layout/admin-layout";
import UserManagement from "./pages/admin/user-management";
import CategoryManagement from "./pages/admin/category-management";
import BackgroundMusicManagement from "./pages/admin/background-music-management";
import TransactionManagement from "./pages/admin/transaction-management";
import BankManagement from "./pages/admin/bank-management";
import AuthorBankApproval from "./pages/admin/author-bank-approval/author-bank-approval.page";
import CreateBook from "./pages/admin/create-book";
import UpdateBook from "./pages/admin/update-book";
import { isAuthenticated } from "./loaders/authentication";
import DeleteAccountPage from "./pages/google-console";
import Otp from "./pages/otp";
import VoucherImport from "./pages/admin/voucher-import";
import AccountInfo from "./pages/admin/account-info";
import BannerManagement from "./pages/admin/banner-management";
import UpdateUser from "./pages/admin/update-user";
import CreateBannerPage from "./pages/admin/create-banner";
import UpdateBannerPage from "./pages/admin/update-banner";
import ContentManagement from "./pages/admin/content-management";
import StatisticsManagement from "./pages/admin/statistics";
import SettingManagement from "./pages/admin/setting-management";
import UpdateSettingPage from "./pages/admin/update-setting";
import CampaignManagement from "./pages/admin/campaign-management";
import UpdateCampaignPage from "./pages/admin/update-campaign";
import CreateCampaignPage from "./pages/admin/create-campaign";
import VoucherActiveManagement from "./pages/admin/voucher-active-management";
import AlertSystemManagement from "./pages/admin/alert-system-management";
import SettingUiManagement from "./pages/admin/setting-ui-management";
import TransferHistoryManagement from "./pages/admin/transfer-histories-management/transfer-histories-management.page";
import BankTransferStatementManagement from "./pages/admin/bank-transfer-statement-management";
import AdvertiseManagement from "./pages/admin/advertise-management";
import CreateAdvertisePage from "./pages/admin/create-advertise/create-advertise.page";
import UpdateAdvertisePage from "./pages/admin/update-advertise/update-advertise.page";
import MediaManagement from "./pages/admin/media-management";
import BookSegmentManagement from "./pages/admin/book-segment-management";
import SqlEditorManagement from "./pages/admin/sql-editor-management/sql-editor-management.page";
import LogManagement from "./pages/admin/log-management";
import BookTimeManagement from "./pages/admin/book-time-management";
import CreateBookTimePage from "./pages/admin/create-book-time";
import UpdateBookTimePage from "./pages/admin/update-book-time";
import FeedManagement from "./pages/admin/feed-management";
import UpdateFeedPage from "./pages/admin/update-feed";
import CommentFeedManagementPage from "./pages/admin/comment-feed-management";
import AffiliateCampaignManagement from "./pages/admin/affiliate-campaign-management";
import CreateAffiliateCampaignPage from "./pages/admin/create-affiliate-campaign";
import UpdateAffiliateCampaignPage from "./pages/admin/update-affiliate-campaign";

const router = createBrowserRouter([
  {
    path: RoutePath.HOME,
    element: <AdminLayout />,
    loader: isAuthenticated,
    children: [
      {
        path: RoutePath.STATISTICS,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <StatisticsManagement />,
          },
        ],
      },
      {
        path: RoutePath.BOOK_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <BookManagement />,
          },
          {
            path: RoutePath.CREATE_BOOK,
            element: <CreateBook />,
          },
          {
            path: RoutePath.UPDATE_BOOK_ID,
            element: <UpdateBook />,
          },
        ],
      },
      {
        path: RoutePath.USER_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <UserManagement />,
          },
          {
            path: RoutePath.UPDATE_USER_ID,
            element: <UpdateUser />,
          },
        ],
      },
      {
        path: RoutePath.LOG_MANAGEMENT,
        element: <LogManagement />,
      },
      {
        path: RoutePath.BOOK_TIME_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <BookTimeManagement />,
          },
          {
            path: RoutePath.CREATE_BOOK_TIME,
            element: <CreateBookTimePage />,
          },
          {
            path: RoutePath.UPDATE_BOOK_TIME_ID,
            element: <UpdateBookTimePage />,
          },
        ],
      },
      {
        path: RoutePath.FEED_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <FeedManagement />,
          },
          {
            path: RoutePath.UPDATE_FEED_ID,
            element: <UpdateFeedPage />,
          },
          {
            path: RoutePath.COMMENT_FEED_MANAGEMENT,
            element: <CommentFeedManagementPage />,
          },
        ],
      },
      {
        path: RoutePath.SQL_EDITOR_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <SqlEditorManagement />,
          },
        ],
      },
      {
        path: RoutePath.CATEGORY_MANAGEMENT,
        element: <CategoryManagement />,
      },
      {
        path: RoutePath.BANNER_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <BannerManagement />,
          },
          {
            path: RoutePath.CREATE_BANNER,
            element: <CreateBannerPage />,
          },
          {
            path: RoutePath.UPDATE_BANNER_ID,
            element: <UpdateBannerPage />,
          },
        ],
      },
      {
        path: RoutePath.AFFILIATE_CAMPAIGN_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AffiliateCampaignManagement />,
          },
          {
            path: RoutePath.CREATE_AFFILIATE_CAMPAIGN,
            element: <CreateAffiliateCampaignPage />,
          },
          {
            path: RoutePath.UPDATE_AFFILIATE_CAMPAIGN_ID,
            element: <UpdateAffiliateCampaignPage />,
          },
        ],
      },
      {
        path: RoutePath.ADVERTISE_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AdvertiseManagement />,
          },
          {
            path: RoutePath.CREATE_ADVERTISE,
            element: <CreateAdvertisePage />,
          },
          {
            path: RoutePath.UPDATE_ADVERTISE_ID,
            element: <UpdateAdvertisePage />,
          },
        ],
      },
      {
        path: RoutePath.CONTENT_MANAGEMENT,
        element: <ContentManagement />,
      },
      {
        path: RoutePath.BACKGROUND_MUSIC_MANAGEMENT,
        element: <BackgroundMusicManagement />,
      },
      {
        path: RoutePath.TRANSACTION_MANAGEMENT,
        element: <TransactionManagement />,
      },
      {
        path: RoutePath.TRANSFER_HISTORY_MANAGEMENT,
        element: <TransferHistoryManagement />,
      },
      {
        path: RoutePath.BANK_TRANSFER_STATEMENT_MANAGEMENT,
        element: <BankTransferStatementManagement />,
      },
      {
        path: RoutePath.BANK_MANAGEMENT,
        element: <BankManagement />,
      },
      {
        path: RoutePath.AUTHOR_BANK,
        element: <AuthorBankApproval />,
      },
      {
        path: RoutePath.VOUCHER_IMPORT,
        element: <VoucherImport />,
      },
      {
        path: RoutePath.ACCOUNT_INFO,
        element: <AccountInfo />,
      },
      // {
      //   path: RoutePath.NOTIFICATION_MANAGEMENT,
      //   element: <Outlet />,
      //   children: [
      //     {
      //       path: "",
      //       element: <NotificationManagement />,
      //     },
      //     {
      //       path: RoutePath.CREATE_NOTIFICATION,
      //       element: <CreateNotification />,
      //     },
      //   ],
      // },
      {
        path: RoutePath.SETTING_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <SettingManagement />,
          },
          {
            path: RoutePath.UPDATE_SETTING_ID,
            element: <UpdateSettingPage />,
          },
        ],
      },
      {
        path: RoutePath.SETTING_UI_MANAGEMENT,
        element: <SettingUiManagement />,
      },
      {
        path: RoutePath.CAMPAIGN_MANAGEMENT,
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <CampaignManagement />,
          },
          {
            path: RoutePath.UPDATE_CAMPAIGN_ID,
            element: <UpdateCampaignPage />,
          },
          {
            path: RoutePath.CREATE_CAMPAIGN,
            element: <CreateCampaignPage />,
          },
        ],
      },
      {
        path: RoutePath.VOUCHER_ACTIVE_MANAGEMENT,
        element: <VoucherActiveManagement />,
      },
      {
        path: RoutePath.ALERT_SYSTEM_MANAGEMENT,
        element: <AlertSystemManagement />,
      },
      {
        path: RoutePath.MEDIA_MANAGEMENT,
        element: <MediaManagement />,
      },
      {
        path: RoutePath.BOOK_SEGMENT_MANAGEMENT,
        element: <BookSegmentManagement />,
      },
    ],
  },

  {
    path: RoutePath.SIGN_IN,
    element: <SignIn />,
    loader: isAuthenticated,
  },
  {
    path: RoutePath.OTP,
    element: <Otp />,
  },
  {
    path: RoutePath.GOOGLE_CONSOLE,
    children: [
      {
        path: "delete",
        element: <DeleteAccountPage />,
      },
    ],
  },
]);

export default router;
